import { headerStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryHeader";
import { clearButtonStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchClearButton";
import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { orderHistorySearchTagsStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags";
import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import { searchFieldWrapperStyles } from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import { ButtonWrapper } from "@insite/mobius/Button";
import { StyledButton } from "@insite/mobius/Clickable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import Filter from "@insite/mobius/Icons/Filter";
import { horizontalStyles } from "@insite/mobius/Tag";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

searchFieldWrapperStyles.wrapper = {
    css: css`
        padding: 10px;
        width: 100%;
        >${FormFieldStyle}{
            >${FormInputWrapper}{
                >div[class^="OverflowWrapper"] {
                    >ul[class^="PopoverStyle"] {
                        >div[class^="Option"] {
                            >div[class^="sc"] {
                                ${TypographyStyle}{
                                    color: ${getColor("secondary")};
                                }
                            }
                        }
                    }
                }
            }
        }
    `,
}

orderHistoryTableStyles.reorderButton = {
    color: "primary",
    sizeVariant: "medium",
}

orderHistoryTableStyles.dataTable = {
    css: css`
    >thead{
        > tr[class^="DataTableHeadStyle"] {
            >${DataTableCellBase}{
                border-bottom: 1px solid ${getColor("common.border")};
                background: ${getColor("info.contrast")};
                >${StyledButton}{
                    ${TypographyStyle}{
                        font-size: 16px;
                        color: ${getColor("primary")};
                    }
                    ${IconWrapper}{
                        color: ${getColor("primary")};
                    }
                }
            }
        }
    }
    >tbody{
        > tr[class^="DataTableRowStyle"] {
            >${DataTableCellBase}{
                >${TypographyStyle}{
                    font-size: 16px;
                    color: ${getColor("secondary")};
                }
            }
        }
    }
    `
}

dateRangeStyles.datePickersWrapper = {
    css: css`
        display: flex;
        > div {
            width: 50%;
            &:last-child {
                > ${FormFieldStyle} {
                    > ${FormInputWrapper} {
                        > div[class^="DateTimePickerStyle"] {
                            > div[class^="react-datetime-picker"] {
                                > span[style^="display: contents;"] {
                                    > div[class^="react-datetime-picker__calendar"] {
                                        > div[class^="react-calendar"] {
                                            ${({ theme }: { theme: BaseTheme }) =>
                                                breakpointMediaQueries(theme, [
                                                    null,
                                                    null,
                                                    null,
                                                    css`
                                                        left: -125px;
                                                    `,
                                                    css`
                                                        left: -90px;
                                                    `,
                                                ])}
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `,
};

clearButtonStyles.clearButton = {
    variant: "secondary",
    css: css`
        float: right;
    `,
};

dateRangeStyles.fromDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-right: 5px;
            > ${FormInputWrapper} {
                > div[class^="DateTimePickerStyle"] {
                    > div[class^="react-datetime-picker"] {
                        padding: 1px 10px 1px 10px;
                    }
                }
            }
        `,
    },
};

dateRangeStyles.toDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-left: 5px;
            > ${FormInputWrapper} {
                > div[class^="DateTimePickerStyle"] {
                    > div[class^="react-datetime-picker"] {
                        padding: 1px 10px 1px 10px;
                    }
                }
            }
        `,
    },
    labelProps: {
        color: "primary.contrast",
    },
};

headerStyles.container = {
    gap: 8,
    css: css`
        padding-bottom: 10px;
    `,
};

headerStyles.toggleFilterIcon = {
    src: Filter,
    size: 24,
    css: css`
        color: ${getColor("primary")};
    `,
};

orderHistorySearchTagsStyles.appliedFiltersContainer = {
    css: css`
        ${horizontalStyles}
        > div[class^="TagStyle"] {
            background-color: ${getColor("primary")};
            color: ${getColor("primary.contrast")};
            >${TypographyStyle}{
                margin: 6px 10px 1px 0;
            }
            > ${ButtonWrapper} {
                background: ${getColor("primary")};
                &:hover {
                    background: #234c9a;
                }
                > ${IconWrapper} {
                    color: ${getColor("primary.contrast")};
                }
            }
        }
    `,
};
